__turbopack_context__.v({
  "closeButton": "-B35Qq_closeButton",
  "content": "-B35Qq_content",
  "divider": "-B35Qq_divider",
  "fullBleed": "-B35Qq_fullBleed",
  "header": "-B35Qq_header",
  "hint": "-B35Qq_hint",
  "idle": "-B35Qq_idle",
  "inputSection": "-B35Qq_inputSection",
  "mt1": "-B35Qq_mt1",
  "root": "-B35Qq_root",
  "title": "-B35Qq_title",
  "toggleButton": "-B35Qq_toggleButton",
  "top": "-B35Qq_top",
  "wrapper": "-B35Qq_wrapper",
});
